import React from 'react';
import { Col, Row } from 'antd';
import styles from './index.less';
import UnoptimizedImage from '../UnoptimizedImage';

const LoyaltyProgramFeature = ({ feature: { description, image, imageAlt } }) => (
  <div className="loyalty-feature">
    <div className="image-wrapper">
      <img src={image} alt={imageAlt} width="100%" />
    </div>
    <p className="feature-description">{description}</p>
  </div>
);

const POSProductFeatures = ({ theme = 'light', title, subTitle = '', featureList }) => {
  let featureSize = featureList.length;
  return (
    <div className={`${styles.ProductFeatures} ${styles[theme]}`}>
      <div className="container common-section feature-section">
        <div className="section-content" style={{ padding: 0 }}>
          <h1 className="bold section-title">
            {title}
            {subTitle && <span className=" section-subtitle">{subTitle}</span>}
          </h1>

          <Row gutter={{ xs: 0, sm: 32 }}>
            {featureList.map((feature, index) => (
              <Col xs={24} md={12} lg={12} xl={24 / featureSize} key={index}>
                <FeatureItem feature={feature} />
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </div>
  );
};

const FeatureItem = ({ feature }) => {
  let { image, imageAlt, title, description } = feature;
  return (
    <div className="feature-item">
      <div style={{ position: 'relative', width: 172, height: 172 }}>
        <UnoptimizedImage src={image} alt={imageAlt} width="172" height="172" objectFit="contain" />
      </div>
      <p className="bold common-title title" style={{ fontSize: '18px' }}>
        {title}
      </p>
      <p className="common-description text-center" dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  );
};

export default POSProductFeatures;
